<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="top clearfix">
                <div class="name">加工全流程</div>
                <div class="back" @click="()=>{ this.$root.$children[0].$children[0].addTab({
                        name: '加工列表',
                        label: '加工列表',
                        content: 'machiningFakeIndex'
                    });}">返回列表</div>
            </div>
            <div class="messBox" :style="'width:'+width+'px;'">
                <div class="time clearfix">
                    <div class="timeC">加工单号：{{dataVal.processing_no}}</div>
                    <div class="timeC">加工厂：{{dataVal.plant_name}}</div>
                    <div class="timeC">加工时间：{{dataVal.processing_time | dateFormat}}</div>
                    <div class="timeC">加工类型：{{dataVal.processing_type==1?"原木到干板":dataVal.processing_type==2?"原木到湿板":"湿板到干板"}}</div>
                    <div class="timeC">锯板单价：{{dataVal.cut_price}}</div>
                    <div class="timeC">烘干单价：{{dataVal.drying_price}}</div>
                    <div class="timeC">薄板单价：{{dataVal.thin_price}}</div>
                </div>
                <div class="remark">
                    <div class="remarkTitle">加工要求:</div>
                    <textarea class="remarkContent" v-model="dataVal.processing_notice" :readonly="true"></textarea>
                    <!-- <div class="remarkContent">{{dataVal.processing_notice}}</div> -->
                </div>
            </div>
            <div class="remarkT" :style="'width:'+width+'px;'">
                <div class="remarkTTitle">备注:</div>
                <div class="remarkTContent">{{dataVal.remark}}</div>
            </div>
            <div class="listBox">
                <div class="listTitle clearfix" v-if="dataVal.processing_type==1||dataVal.processing_type==2">
                    <span class="listTitleS">原木清单汇总</span>
                </div>
                <div class="table" v-if="dataVal.processing_type==1||dataVal.processing_type==2">
                    <el-table :data="dataVal.wood_list" ref="wood_list" border stripe highlight-current-row size="mini">
                        <el-table-column label="操作"  width="95">
                            <template slot-scope="scope">
                                <div class="icon_wrap">
                                    <i class="operation_add" title="新增"></i>
                                    <i class="operation_edit" @click="materialDialog=!materialDialog;materialEditForm=JSON.parse(JSON.stringify(scope.row));materialEditForm.processing_id=id;" title="修改"></i>
                                    <i class="operation_delete" @click="deleteDetail(scope.row,'/erp/processing.delete.batch.wood')" title="删除"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="合同号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.contract_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="批次号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.batch_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="船名" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.ship_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="树种" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.breed }}
                            </template>
                        </el-table-column>
                        <el-table-column label="根数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.count }}
                            </template>
                        </el-table-column>
                        <el-table-column label="方数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.cube }}
                            </template>
                        </el-table-column>
                        <el-table-column label="据板单价" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.cut_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="据板总费用" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.cut_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="薄板方数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.thin_cube }}
                            </template>
                        </el-table-column>
                        <el-table-column label="薄板加工单价" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.thin_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="薄板加工费用" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.thin_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="运费单价" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.freight_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="预计完成时间" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.expected_finish_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.remark }}
                            </template>
                        </el-table-column>
                        <el-table-column label="原木码单明细" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="tdClick" @click="seeDetail(scope.row,'wood')">
                                    <div class="tdClickImage"></div>
                                    {{ '查看详情' }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="listTitle clearfix" v-if="dataVal.processing_type==1||dataVal.processing_type==2">
                    <span class="listTitleS">三角料清单汇总</span>
                    <div class="listTitleBtn" @click="addWoodList">添加三角料</div>
                </div>
                <div class="table" v-if="dataVal.processing_type==1||dataVal.processing_type==2">
                    <el-table :data="dataVal.triangle_list" ref="triangle_list" border stripe highlight-current-row size="mini">
                        <el-table-column label="操作"  width="75">
                            <template slot-scope="scope">
                                <div class="icon_wrap">
                                    <i class="operation_edit" @click="editTrangle(scope.row)" title="修改"></i>
                                    <i class="operation_delete" @click="deleteDetail(scope.row,'/erp/processing.delete.batch.triangle')" title="删除"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="合同号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.contract_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="批次号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.batch_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="加工单号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.processing_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="船名" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.ship_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="品名" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.breed }}
                            </template>
                        </el-table-column>
                        <el-table-column label="包/吨数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.total }}
                            </template>
                        </el-table-column>
                        <el-table-column label="销售单价" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.sales_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="销售金额" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.sales_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.remark }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="listTitle clearfix" v-if="dataVal.processing_type==1||dataVal.processing_type==2||dataVal.processing_type==3">
                    <span class="listTitleS">湿板清单汇总</span>
                    <div class="listTitleBtn" v-if="dataVal.processing_type!=3" @click="importDialogVisible=true;importType=2;importName='上传湿板码单';importCode='qc_water_stock';importUrl='/erp/import.processing.water'">上传湿板码单</div>
                </div>
                <div class="table" v-if="dataVal.processing_type==1||dataVal.processing_type==2||dataVal.processing_type==3">
                    <el-table :data="dataVal.wet_list" ref="wet_list" border stripe highlight-current-row size="mini">
                        <el-table-column label="操作"  width="75">
                            <template slot-scope="scope">
                                <div class="icon_wrap">
                                    <i class="operation_edit" @click="wetDialog=!wetDialog;wetEditForm=JSON.parse(JSON.stringify(scope.row));wetEditForm.processing_id=id;" title="修改"></i>
                                    <i class="operation_delete" @click="deleteDetail(scope.row,'/erp/processing.delete.batch.wet')" title="删除"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="湿板批次号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.wet_wood_batch }}
                            </template>
                        </el-table-column>
                        <el-table-column label="品名" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.breed }}
                            </template>
                        </el-table-column>
                        <el-table-column label="品牌" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.brand }}
                            </template>
                        </el-table-column>
                        <el-table-column label="厚度" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.thickness }}
                            </template>
                        </el-table-column>
                        <el-table-column label="长度" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.length }}
                            </template>
                        </el-table-column>
                        <el-table-column label="件数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.count }}
                            </template>
                        </el-table-column>
                        <el-table-column label="方数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.cube }}
                            </template>
                        </el-table-column>
                        <el-table-column label="窑号" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.kiln_no }}
                            </template>
                        </el-table-column>
                        <el-table-column label="入窑时间" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.kiln_in_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="预计出窑时间" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.expected_kiln_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="烘干单价" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.drying_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="烘干总费用" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.drying_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="运费单价" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.freight_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际收货日期" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.receiving_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="收货人" width="90" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.receiving_man }}
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.remark }}
                            </template>
                        </el-table-column>
                        <el-table-column label="湿板码单明细" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="tdClick" @click="seeDetail(scope.row,'wet')">
                                    <div class="tdClickImage"></div>
                                    {{ '查看详情' }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="listTitle clearfix" v-if="dataVal.processing_type==1||dataVal.processing_type==3">
                    <span class="listTitleS">干板清单汇总</span>
                    <div class="listTitleBtn" @click="importDialogVisible=true;importType=3;importName='上传干板码单';importCode='qc_dry_stock';importUrl='/erp/import.processing.dry'">上传干板码单</div>
                </div>
                <div class="table" v-if="dataVal.processing_type==1||dataVal.processing_type==3">
                    <el-table :data="dataVal.dry_list" ref="dry_list" border stripe highlight-current-row size="mini">
                        <el-table-column label="操作"  width="75">
                            <template slot-scope="scope">
                                <div class="icon_wrap">
                                    <i class="operation_edit" @click="dryDialog=!dryDialog;dryEditForm=JSON.parse(JSON.stringify(scope.row));dryEditForm.processing_id=id;" title="修改"></i>
                                    <i class="operation_delete" @click="deleteDetail(scope.row,'/erp/processing.delete.batch.dry')" title="删除"></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="干板批次号" width="135" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.dry_wood_batch }}
                            </template>
                        </el-table-column>
                        <el-table-column label="品名" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.breed }}
                            </template>
                        </el-table-column>
                        <el-table-column label="品牌" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.brand }}
                            </template>
                        </el-table-column>
                        <el-table-column label="厚度" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.thickness }}
                            </template>
                        </el-table-column>
                        <el-table-column label="长度" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.length }}
                            </template>
                        </el-table-column>
                        <el-table-column label="件数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.count }}
                            </template>
                        </el-table-column>
                        <el-table-column label="方数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.cube }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际出窑时间" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.kiln_out_time }}
                            </template>
                        </el-table-column>
                        <el-table-column label="烘干天数" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.drying_days }}
                            </template>
                        </el-table-column>
                        <el-table-column label="打包费" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.pack_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="运费单价" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.freight_price }}
                            </template>
                        </el-table-column>
                        <el-table-column label="其他费用" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.other_amount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="缩水率" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.shrink_rate }}
                            </template>
                        </el-table-column>
                        <el-table-column label="入库人" width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.stock_in_man }}
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.remark }}
                            </template>
                        </el-table-column>
                        <el-table-column label="干板码单明细" width="100" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="tdClick" @click="seeDetail(scope.row,'dry')">
                                    <div class="tdClickImage"></div>
                                    {{ '查看详情' }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">原木方数:{{totalObj.wood_cube}}</div>
                <div class="totalNumber">湿板方数:{{totalObj.wet_wood_cube}}</div>
                <div class="totalNumber">干板方数:{{totalObj.dry_wood_cube}}</div>
                <div class="totalNumber">总费用:{{totalObj.processing_amount}}</div>
                <div class="totalNumber">总耗时:{{totalObj.processing_duration}}</div>
            </div>
        </div>
        <!-- 添加三角料 dialog START -->
        <el-dialog v-dialog-drag title="三角料" :visible.sync="wood_listDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="wood_listAddForm" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="合同号：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.contract_no" ></el-input>
                    </el-form-item>
                    <el-form-item label="批次号：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.batch_no" ></el-input>
                    </el-form-item>
                    <el-form-item label="加工单号：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.processing_no" ></el-input>
                    </el-form-item>
                    <el-form-item label="船名：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.ship_no" ></el-input>
                    </el-form-item>
                    <el-form-item label="品名：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.breed" ></el-input>
                    </el-form-item>
                    <el-form-item label="包/吨数：">
                        <el-input v-model="wood_listAddForm.total" @input="calWoodPrice"></el-input>
                    </el-form-item>
                    <el-form-item label="销售单价：">
                        <el-input v-model="wood_listAddForm.sales_price" @input="calWoodPrice"></el-input>
                    </el-form-item>
                    <el-form-item label="销售金额：" v-if="TrangleType==2">
                        <el-input v-model="wood_listAddForm.sales_total" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="wood_listAddForm.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="wood_listDialogVisible=!wood_listDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="wood_listAdd">确定</el-button>
            </div>
        </el-dialog>
        <!-- 添加三角料 dialog END -->
        <!--导入 START -->
         <el-dialog v-dialog-drag :title="importName" :visible.sync="importDialogVisible" class="eldialog eldialogA" :modal="false" width='500px'>
			<div class="text-center"  style="margin-top:20px;">
				<el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
					<div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:20px;">只能上传Excel文件</div>
				</el-upload>
				<div class="">
					<el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
				</div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--导入 END -->
        <!--修改湿板 START -->
        <el-dialog v-dialog-drag title="湿板" :visible.sync="wetDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="wetEditForm" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="湿板批次号：">
                        <el-input v-model="wetEditForm.wet_wood_batch" ></el-input>
                    </el-form-item>
                    <el-form-item label="运费单价：">
                        <el-input v-model="wetEditForm.freight_price" ></el-input>
                    </el-form-item>
                    <el-form-item label="窑号：">
                        <el-input v-model="wetEditForm.kiln_no" ></el-input>
                    </el-form-item>
                    <el-form-item label="入窑时间：">
                        <el-date-picker v-model="wetEditForm.kiln_in_time" type="date" placeholder="入窑时间："></el-date-picker>
                        <!-- <el-input v-model="wetEditForm.kiln_in_time" ></el-input> -->
                    </el-form-item>
                    <el-form-item label="预计出窑时间：">
                        <el-date-picker v-model="wetEditForm.expected_kiln_time" type="date" placeholder="预计出窑时间："></el-date-picker>
                        <!-- <el-input v-model="wetEditForm.expected_kiln_time" ></el-input> -->
                    </el-form-item>
                    <el-form-item label="实际收货日期：">
                        <el-date-picker v-model="wetEditForm.receiving_time" type="date" placeholder="实际收货日期："></el-date-picker>
                        <!-- <el-input v-model="wetEditForm.receiving_time" ></el-input> -->
                    </el-form-item>
                    <el-form-item label="收货人：">
                        <el-input v-model="wetEditForm.receiving_man" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="wetEditForm.remark" ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="wetDialog=!wetDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="wetEdit">确定</el-button>
            </div>
        </el-dialog>
        <!--修改湿板 END -->
        <!--修改干板 START -->
        <el-dialog v-dialog-drag title="干板" :visible.sync="dryDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="dryEditForm" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <!-- <el-form-item label="干板批次号：">
                        <el-input v-model="dryEditForm.dry_wood_batch" ></el-input>
                    </el-form-item> -->
                    <el-form-item label="运费单价：">
                        <el-input v-model="dryEditForm.freight_price" ></el-input>
                    </el-form-item>
                    <el-form-item label="其他费用：">
                        <el-input v-model="dryEditForm.other_amount" ></el-input>
                    </el-form-item>
                    <el-form-item label="打包费单价：">
                        <el-input v-model="dryEditForm.pack_price" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="dryEditForm.remark" ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dryDialog=!dryDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="dryEdit">确定</el-button>
            </div>
        </el-dialog>
        <!--修改干板 END -->
        <!--修改原料 START -->
        <el-dialog v-dialog-drag title="原木" :visible.sync="materialDialog" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="materialEditForm" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <!-- <el-form-item label="批次号：">
                        <el-input v-model="materialEditForm.batch_no" ></el-input>
                    </el-form-item> -->
                    <el-form-item label="薄板方数：">
                        <el-input v-model="materialEditForm.thin_cube" ></el-input>
                    </el-form-item>
                    <el-form-item label="运费单价：">
                        <el-input v-model="materialEditForm.freight_price" ></el-input>
                    </el-form-item>
                    <el-form-item label="预计完成时间：">
                        <el-date-picker v-model="materialEditForm.expected_finish_time" type="date" placeholder="预计完成时间"></el-date-picker>
                        <!-- <el-input v-model="materialEditForm.expected_finish_time" ></el-input> -->
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="materialEditForm.remark" ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="materialDialog=!materialDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="materialEdit">确定</el-button>
            </div>
        </el-dialog>
        <!--修改原料 END -->
    </div>
</template>
<style scoped lang="scss">
    .tdClick{cursor: pointer;color:#ff0000;text-decoration: underline;}
    .top{}
    .top .name{float: left;}
    .top .back{float: right;font-size: 14px;color:#b21111;cursor: pointer;}
    .messBox{background-color: #ebedf3;padding:10px;border-radius: 5px;margin-top:15px;}
    .messBox .time{padding:10px 0;border-bottom:1px solid #fff;}
    .messBox .timeC{font-size: 12px;float: left;color:#333;margin-right:15px;border:1px solid #ccc;border-radius: 3px;padding:5px 10px;}
    .messBox .remark{height:80px;padding:10px;box-sizing: border-box;padding-left: 60px;position: relative;}
    .messBox .remarkTitle{width:60px;position: absolute;top:10px;left:0px;font-size: 12px;color:#333;text-align: left;}
    .messBox .remarkContent{font-size: 12px;color:#333;text-align: left;width:100%;resize: none;border:0;background: none;outline: none;height:100%;}
    .remarkT{height:40px;padding:10px;box-sizing: border-box;padding-left: 45px;position: relative;display:block;border:1px solid #ccc;border-radius: 5px;}
    .remarkTTitle{width:30px;position: absolute;top:10px;left:10px;font-size: 12px;color:#333;text-align: left;}
    .remarkTContent{font-size: 12px;color:#333;text-align: left;}
    .listBox{flex:1;overflow: auto;}
    .listBox .listTitle{font-size: 15px;padding-bottom:5px;text-align: left;margin-top:25px;}
    // .listTitleS{float: left;}
    .listTitleBtn{background-color: #b21111;color:#fff;font-size: 12px;display: inline-block;padding:5px 10px;border-radius: 3px;margin-left:10px;cursor: pointer;}
</style>
<script>
    export default {
        components:{
        },
        created(){
            this.id = sessionStorage.getItem("DEMU_ERP_PURCHASE_MACHINDETAIL_ID")
            sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_ID")
            this.getDetail()
        },
        data(){
            return{
                id:"",
                listDetailed:[],
                dataVal:{},
                totalObj:{},
                materialEditForm:{
                    processing_id:"",
                    batch_no:"",
                    thin_cube:"",
                    freight_price:"",
                    expected_finish_time:"",
                    remark:""
                },
                materialDialog:false,
                wetDialog:false,
                wetEditForm:{
                    processing_id:"",
                    wet_wood_batch:"",
                    freight_price:"",
                    remark:"",
                    kiln_no:"",
                    kiln_in_time:"",
                    expected_kiln_time:"",
                    receiving_time:"",
                    receiving_man:""
                },
                dryDialog:false,
                dryEditForm:{
                    processing_id:"",
                    dry_wood_batch:"",
                    freight_price:"",
                    other_amount:"",
                    pack_price:"",
                    remark:""
                },
                wood_listDialogVisible:false,
                wood_listAddForm:{
                    processing_id:"",
                    processing_no:"",
                    batch_no:"",
                    contract_no:"",
                    ship_no:"",
                    breed:"",
                    total:"",
                    sales_price:"",
                    sales_total:"",
                    remark:""
                },
                TrangleType:2,//三角料 2新增 3修改
                importDialogVisible:false,
                importType:2,//上传 2湿板 3干板
                importName:"上传湿板码单",
                importCode:"qc_water_stock",
                importUrl:"/erp/import.processing.water",
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                width:872,
            }
        },
        methods:{
            seeDetail(row,type){
                if(type=="wet"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL",this.id)
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL_BATCH")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WETDETAIL_BATCH",row.wet_wood_batch)
                    this.$root.$children[0].$children[0].addTab({
                        name: '湿板码单明细'+this.id,
                        label: '湿板码单明细',
                        content: 'machiningwetDetail'
                    });
                }else if(type=="dry"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_DRYDETAIL")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_DRYDETAIL",this.id)
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_DRYDETAIL_BATCH")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_DRYDETAIL_BATCH",row.dry_wood_batch)
                    this.$root.$children[0].$children[0].addTab({
                        name: '干板码单明细'+this.id,
                        label: '干板码单明细',
                        content: 'machiningdryDetail'
                    });
                }else if(type=="wood"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WOODDETAIL")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_MACHINDETAIL_WOODDETAIL",this.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '原木码单明细'+this.id,
                        label: '原木码单明细',
                        content: 'machiningwoodDetail'
                    });
                }
            },
            materialEdit(){
                let times = this.materialEditForm.expected_finish_time;
                this.materialEditForm.expected_finish_time = this.formatTimeZero(this.materialEditForm.expected_finish_time);
                this.postFuncLoading("/erp/processing.update.batch.wood",this.materialEditForm,()=>{
                    this.tip("操作成功","success")
                    this.materialDialog = false;
                    this.getDetail();
                },error=>{
                    this.materialEditForm.expected_finish_time = times;
                    this.tip(error.data.message,"warning")
                },()=>{
                    this.materialEditForm.expected_finish_time = times;
                })
            },
            dryEdit(){
                this.postFuncLoading("/erp/processing.update.batch.dry",this.dryEditForm,()=>{
                    this.tip("操作成功","success")
                    this.dryDialog = false;
                    this.getDetail();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            wetEdit(){
                let kiln_in_time = this.wetEditForm.kiln_in_time;
                let expected_kiln_time = this.wetEditForm.expected_kiln_time;
                let receiving_time = this.wetEditForm.receiving_time;
                this.wetEditForm.kiln_in_time = this.formatTimeZero(this.wetEditForm.kiln_in_time);
                this.wetEditForm.expected_kiln_time = this.formatTimeZero(this.wetEditForm.expected_kiln_time);
                this.wetEditForm.receiving_time = this.formatTimeZero(this.wetEditForm.receiving_time);
                this.postFuncLoading("/erp/processing.update.batch.wet",this.wetEditForm,()=>{
                    this.tip("操作成功","success")
                    this.wetDialog = false;
                    this.getDetail();
                },error=>{
                    this.tip(error.data.message,"warning")
                    this.wetEditForm.kiln_in_time = kiln_in_time;
                    this.wetEditForm.expected_kiln_time = expected_kiln_time;
                    this.wetEditForm.receiving_time = receiving_time;
                },()=>{
                    this.wetEditForm.kiln_in_time = kiln_in_time;
                    this.wetEditForm.expected_kiln_time = expected_kiln_time;
                    this.wetEditForm.receiving_time = receiving_time;
                })
            },
            calWoodPrice(val){
                if(Number(val)){
                    let number = 0;
                    if(Number(this.wood_listAddForm.total)&&Number(this.wood_listAddForm.sales_price)){
                        number = Number(this.wood_listAddForm.total) * Number(this.wood_listAddForm.sales_price)
                    }
                    this.wood_listAddForm.sales_total = this.keepPrice(number)
                }
            },
            deleteDetail(row,url){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading(url,{processing_id:this.id,batch_no:row.batch_no,dry_wood_batch:row.dry_wood_batch,wet_wood_batch:row.wet_wood_batch},()=>{
                        this.tip("删除成功","success")
                        this.getDetail()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            editTrangle(row){
                this.wood_listAddForm = JSON.parse(JSON.stringify(row))
                this.wood_listDialogVisible = true;
                this.wood_listAddForm.sales_total = this.wood_listAddForm.total * this.wood_listAddForm.sales_price;
                this.TrangleType = 3;
            },
            addWoodList(){
                this.wood_listAddForm.contract_no = this.dataVal.wood_list[0].contract_no;
                this.wood_listAddForm.batch_no = this.dataVal.wood_list[0].batch_no;
                this.wood_listAddForm.processing_no = this.dataVal.processing_no;
                this.wood_listAddForm.ship_no = this.dataVal.wood_list[0].ship_no;
                this.wood_listAddForm.breed = "三角料";
                this.wood_listAddForm.processing_id = this.id;
                this.wood_listDialogVisible = true;
                this.TrangleType = 2;
            },
            wood_listAdd(){
                let url = '';
                if(this.TrangleType==2){
                    url = "/erp/processing.triangle.add";
                }else{
                    url = "/erp/processing.triangle.edit";
                }
                this.postFuncLoading(url,this.wood_listAddForm,()=>{
                    this.tip("操作成功","success")
                    this.wood_listDialogVisible = false;
                    this.getDetail();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getDetail(){
                this.postFunc("/erp/processing.details",{id:this.id},res=>{
                    this.dataVal = res.data.data;
                    let plant_name_width = this.dataVal.plant_name.length*15;
                    let cut_price_width = this.dataVal.cut_price.length*11;
                    let drying_price_width = this.dataVal.drying_price.length*11;
                    let thin_price_width = this.dataVal.thin_price.length*11;
                    this.width = 872;
                    this.width = this.width + plant_name_width + cut_price_width + drying_price_width + thin_price_width;
                    this.totalObj.wood_cube = res.data.data.wood_cube;
                    this.totalObj.wet_wood_cube = res.data.data.wet_wood_cube;
                    this.totalObj.dry_wood_cube = res.data.data.dry_wood_cube;
                    this.totalObj.processing_amount = res.data.data.processing_amount;
                    this.totalObj.processing_duration = res.data.data.processing_duration;
                    this.dataVal.wet_list.forEach((item,index)=>{
                        if(item.kiln_in_time!=0){
                            this.dataVal.wet_list[index].kiln_in_time = this.formatTime(item.kiln_in_time*1000)
                        }else{
                            item.kiln_in_time = "";
                        }
                        if(item.expected_kiln_time!=0){
                            this.dataVal.wet_list[index].expected_kiln_time = this.formatTime(item.expected_kiln_time*1000)
                        }else{
                            item.expected_kiln_time = "";
                        }
                        if(item.receiving_time!=0){
                            this.dataVal.wet_list[index].receiving_time = this.formatTime(item.receiving_time*1000)
                        }else{
                            item.receiving_time = "";
                        }
                    })
                    this.dataVal.dry_list.forEach((item,index)=>{
                        if(item.kiln_out_time!=0){
                            this.dataVal.dry_list[index].kiln_out_time = this.formatTime(item.kiln_out_time*1000)
                        }else{
                            item.kiln_out_time = "";
                        }
                    })
                    this.dataVal.wood_list.forEach((item,index)=>{
                        if(item.expected_finish_time!=0){
                            this.dataVal.wood_list[index].expected_finish_time = this.formatTime(item.expected_finish_time*1000)
                        }else{
                            item.expected_finish_time = "";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis(this.importUrl,this.file_url,"","",this.id,response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getDetail()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            downTemplete(){
                this.exportFile(this.importCode,"","",this.id,response=>{
					const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
					const fileName = (this.importType==2?"湿板码单导入":"干板码单导入")+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            wood_listDialogVisible:function(val){
                if(!val){
                    this.wood_listAddForm = this.resetJson(this.wood_listAddForm)
                }
            }
        }
    }
</script>
